export default __webpack_public_path__ + "static/media/correct8.edcc342b.mp3";